module.exports = __webpack_public_path__ + "static/img/third1_2_1.4f107cb8.png";